import { defineAsyncComponent, hydrateOnVisible } from "vue";
export default class ComponentFactory {
    // #region Vars
    _app;
    _componentRegistry = new Map();
    _instances = new Map();
    // #endregion
    // #region Properties
    //fileFilter?: RegExp = /(?<!views)\.vue$/;
    // #endregion
    // #region Constructor
    constructor(app) {
        this._app = app;
    }
    // #endregion
    // #region Common
    getComponentRegistry() {
        return this._componentRegistry;
    }
    // #endregion
    // #region Component
    getComponent(name) {
        return this._app.component(name);
    }
    load(Components) {
        Components.forEach((e) => {
            if (utils.isNullOrEmpty(e.name)) {
                utils.logWarning("No name is provided for component.", e);
                return;
            }
            if (this._componentRegistry.has(e.name)) {
                this._componentRegistry.delete(e.name);
            }
            this._componentRegistry.set(e.name, e);
        });
    }
    loadSingle(component) {
        if (utils.isNullOrEmpty(component.name)) {
            utils.logWarning("No name is provided for component.", component);
            return;
        }
        if (this._componentRegistry.has(component.name)) {
            this._componentRegistry.delete(component.name);
        }
        this._componentRegistry.set(component.name, component);
    }
    registerAll(context) {
        context.keys().forEach(e => {
            try {
                //View
                let tView = context(e).default;
                //Append
                this.loadSingle(tView);
            }
            catch (e) {
                alert("ComponentFactory.registerAll => " + e + " - " + e);
            }
        });
    }
    registerAsync(name, loader) {
        if (utils.isNullOrEmpty(name)) {
            utils.logWarning("No name is provided for component.", name);
            return;
        }
        if (this._componentRegistry.has(name)) {
            this._componentRegistry.delete(name);
        }
        this._componentRegistry.set(name, defineAsyncComponent({
            loader: loader,
            hydrate: hydrateOnVisible()
        }));
    }
    // #endregion
    // #region Instances
    getInstances() {
        let tArray = [];
        this._instances.forEach((value, key, map) => {
            tArray.push({ uid: key, typeName: value.$.type?.name, component: value });
        });
        return tArray;
    }
    getInstance(uid) {
        return this._instances.get(uid);
    }
    setInstance(object) {
        if (object.$.uid) {
            this._instances.set(object.$.uid, object);
        }
    }
    removeInstance(object) {
        if (object.$.uid) {
            this._instances.delete(object.$.uid);
        }
    }
}
